export default __webpack_public_path__ + "static/banner-6a273fe2aac90c814167ef6e627e4042.png";